<template>
    <div class="map" style="width: 100%; height: 100%; overflow: hidden">
        <client-only>
            <GoogleMap
                v-if="activeStore"
                ref="map"
                :lat="Number(activeStore?.coordinates?.lat)"
                :lng="Number(activeStore?.coordinates?.lng)"
                :mapZoom="zoom"
                :shops="stores"
                :iframe="activeStore?.iframe"
            />
        </client-only>
    </div>
</template>

<script>
import VueTypes, { nullable } from 'vue-types';

import { StoreItem } from '../../types';

export default {
    name: 'Map',
    components: {
        GoogleMap: () => import('~/components/GoogleMap')
    },
    props: {
        stores: VueTypes.arrayOf(StoreItem).isRequired,
        iconStoreActive: VueTypes.oneOfType([String, nullable]).isRequired,
        iconStoreDisabled: VueTypes.oneOfType([String, nullable]).isRequired,
        activeStore: VueTypes.oneOfType([StoreItem, nullable]).def(null)
    },
    data() {
        return {
            mapSettings: {
                apiKey: '868ca9db-26b0-402f-b827-99a3773a053c',
                webvisor: false,
                lang: null,
                coordorder: 'latlong',
                enterprise: false,
                version: '2.1'
            },
            zoom: 13
        };
    },
    watch: {
        activeStore() {
            this.zoomToActiveStore();
        },
        currentLocaleIso: {
            immediate: true,
            handler(val) {
                this.mapSettings.lang = val;
            }
        }
    },
    computed: {
        currentLocaleIso() {
            return this.$i18n.locales.find(i => i.code === this.$i18n.locale).iso?.replace('-', '_');
        },
        coordinates() {
            const shopCoordinates = this.activeStore?.coordinates;
            return shopCoordinates ? Object.values(shopCoordinates) : [47.01630215634318, 28.8734796670343]; // Default to Chisinau if no coordinates
        }
    },
    methods: {
        getMarkerIcon(shop) {
            return {
                layout: 'default#image',
                imageHref: this.activeStore?.isOpen ? this.iconStoreActive : this.iconStoreDisabled,
                iconImageSize: [40, 40],
                iconImageOffset: [0, 0],
                contentOffset: [0, 0],
                contentLayout: this.contentLayout,
                clusterDisableClickZoom: true,
                clusterOpenBalloonOnClick: true
            };
        },
        zoomToActiveStore() {
            this.zoom = 16;
        }
    },
    mounted() {
        if (this.activeStore) this.zoomToActiveStore();
    }
};
</script>
